export const COMMUNITY_NAME = "name";
export const COMMUNITY_REGISTERED_NAME = "registeredName";
export const LANGUAGE = "languageCode";
export const UNITS = "units";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const ZIPCODE = "zipCode";
export const STATE = "state";
export const AUDIT_STATE = "auditState";
export const CITY = "city";
export const COUNTY = "county";
export const AUDIT_SCOPE = "auditScope";
export const LICENSE_CATEGORY = "licenseCategory";
export const GENERAL_PHONE = "generalPhoneNo";
export const EMERGENCY_PHONE = "emergencyPhoneNo";
export const MANAGER_NAME = "communityManagerId";
export const MANAGER_PHONE = "propertyManagerPhone";
export const CONTACT_EMAIL = "contactEmail";
export const WEBSITE = "websiteUrl";
export const ACCOUNTING_METHOD = "accountingMethod";

export const auditScopeOptions = [
  {label: 'State', value: 'STATE'},
  {label: 'Federal', value: 'FEDERAL'},
]

export const licenseCategoryOptions = [
  {label: 'Bi-Party', value: 'BI_PARTY'},
  {label: 'Tri-Party', value: 'TRI_PARTY'},
]

export const accountingMethodOptions = [
  {label: 'Accrual', value: 'ACCRUAL'},
  {label: 'Cash', value: 'CASH'},
]
